import { render } from "./BioCard.vue?vue&type=template&id=88de9a22&scoped=true"
import script from "./BioCard.vue?vue&type=script&lang=js"
export * from "./BioCard.vue?vue&type=script&lang=js"

import "./BioCard.vue?vue&type=style&index=0&id=88de9a22&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-88de9a22"

export default script